<template>
    <CLoader :pConfigLoad="ConfigLoad">
        <template slot="BodyFormLoad">
            <form id="FormTiposLentesxSublineas" class="form-horizontal" method="post" autocomplete="off" onSubmit="return false">
                <div class="container-fluid">
                    <div class="row">
                        <div class="col-12 col-sm-12 col-md-12 col-lg-12">
                            <div class="form-group row">
                                <div v-for="(item,index) in SublineaLista" :key="index" class="col-12 col-sm-6 col-md-6 col-lg-4 col-xl-4">
                                    <div class="form-check-inline form-check form-switch form-sw">
                                        <input :value="item.IdSublinea" v-model="objTiposLentexSublinea.Sublineas" class="form-check-input" role="switch" type="checkbox" :id="'sub_'+index">
                                        <label class="form-check-label" :for="'sub_'+index">{{ item.Nombre }} ({{ item.Clave }})</label>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </form>
        </template>
    </CLoader>
</template>
<script>
export default{
    name: 'FormTipoLentexSublinea',
    props: ['poBtnSave','pIdTipoLente'],
    data(){
        return{
            ConfigLoad:{
                ShowLoader: true,
                ClassLoad: false,
            },
            objTiposLentexSublinea: {
                Sublineas:[],
				IdTipoLente: 0,
            },
            errorvalidacion: [],
			Emit: this.poBtnSave.EmitSeccion,
            SublineaLista:[]
        }
    },
    methods:{
        async Guardar(){
            this.poBtnSave.DisableBtn = true;
            let formData=new FormData();
            formData.set('IdTipoLente',this.objTiposLentexSublinea.IdTipoLente);
            formData.set('Sublineas',JSON.stringify(this.objTiposLentexSublinea.Sublineas));
            await this.$http.post('tiposlentesxsublinea',formData).then((res)=>{
                this.EjecutaConExito(res);
            }).catch((err)=>{
                this.EjecutaConError(err);
            });
        },
        EjecutaConExito(res){
            this.poBtnSave.DisableBtn = false;  
            this.poBtnSave.Toast = 1;
            this.bus.$emit('CloseModal_'+this.Emit);
            this.bus.$emit('List_'+this.Emit);
        },
        EjecutaConError(err){
            this.poBtnSave.DisableBtn = false;
            
            if(err.response.data.errors){
                this.errorvalidacion = err.response.data.errors;
                this.poBtnSave.Toast = 2;
            }
            else{
                this.$toast.error(err.response.data.message);
            }
        },
        Limpiar(){
            this.errorvalidacion=[];
            this.objTiposLentexSublinea.Sublineas=[];
            this.SublineaLista=[];
        },
        async Recuperar(){
            await this.$http.get('tiposlentesxsublineasimple',{
                params:{
                    IdTipoLente:this.objTiposLentexSublinea.IdTipoLente
                }
            }).then((res)=>{
                res.data.data.forEach(element => {
                    this.objTiposLentexSublinea.Sublineas.push(element.IdSublinea);
                });
            }).finally(()=>{
                this.ConfigLoad.ShowLoader=false;
            })
        },
        async GetSublineaLista(){
            await this.$http.get('grupolineassimple').then((res)=>{
                this.SublineaLista=res.data.data;
                this.Recuperar();
            });
        }
    },
    created(){
        this.bus.$off('Recovery_'+this.Emit);
        this.bus.$off('Save_'+this.Emit);
    },
    mounted(){
        this.bus.$on('Recovery_'+this.Emit,()=>{
            this.objTiposLentexSublinea.IdTipoLente=this.pIdTipoLente;
            this.bus.$on('Save_'+this.Emit,()=>{
                this.Guardar();
            });
            this.GetSublineaLista();
        });
    }
}
</script>